import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import RequestTrackingServices from "./RequirementsMonitor.services";
import { downloadDocument } from "../../../components/gestorDocumental/GestorDocumental";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getRequestTracking = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_REQUEST_TRACKING,
      payload: true,
    });
    const resp = await RequestTrackingServices.getRequestTracking(filters);
    dispatch({
      type: actions.GET_REQUEST_TRACKING,
      payload: {
        requestTrackings: resp.data.data,
        requestTrackingsLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.REQUEST_TRACKING_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.REQUEST_TRACKING_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_REQUEST_TRACKING,
      payload: false,
    });
  }
};

export const getRequestTrackingById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_REQUEST_TRACKING,
      payload: true,
    });
    const resp = await RequestTrackingServices.getRequestTrackingById(id);
    dispatch({
      type: actions.GET_REQUEST_TRACKING,
      payload: {
        requestTracking: resp.data
      },
    });
    dispatch({
      type: actions.REQUEST_TRACKING_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.REQUEST_TRACKING_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_REQUEST_TRACKING,
      payload: false,
    });
  }
};

export const saveRequestTracking = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_REQUEST_TRACKING,
      payload: true,
    });
    const resp = await RequestTrackingServices.saveRequestTracking(data);
    const { requestTrackings, requestTrackingsLength } = getState().requestTracking;
    const _requestTracking = [...requestTrackings, resp.data];
    const _data = resp.data
    dispatch({
      type: actions.GET_REQUEST_TRACKING,
      payload: {
        requestTrackings: _requestTracking,
        requestTrackingsLength: requestTrackingsLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
    {/**const mail = {
      data: [
        {
          plaza_id: _data.plaza,
          tipo_mensaje: "Responsable envía candidatos"
        }
      ]
    }
    toastr.success(messages.correoEnviado, '', {
      progressBar: true,
      rtl: true,
    });
  //await RequestTrackingServices.mailSendRequestTracking(mail) */}
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_REQUEST_TRACKING,
      payload: false,
    });
  }
};

export const sendMailForCandidates = (data) => async (dispatch, getState) => {
  try {
    const mail = {
      data: [
        {
          plaza_id: data.plaza,
          tipo_mensaje: "Responsable envía candidatos"
        }
      ]
    }
    toastr.success(messages.correoEnviado, '', {
      progressBar: true,
      rtl: true,
    });
    await RequestTrackingServices.mailSendRequestTracking(mail)
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }
}

export const editRequestTracking = (data, editItem, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_REQUEST_TRACKING,
      payload: true,
    });
    const resp = await RequestTrackingServices.editRequestTracking(editItem.id, data);
    const { requestTrackings, requestTrackingsLength } = getState().requestTracking;
    requestTrackings[index] = resp.data;
    dispatch({
      type: actions.GET_REQUEST_TRACKING,
      payload: {
        requestTrackings: requestTrackings,
        requestTrackingsLength: requestTrackingsLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
    if (editItem.calificacion !== resp.data.calificacion || editItem.descripcion_calificacion !== resp.data.descripcion_calificacion) {
      const mail = {
        data: [
          {
            postulante_id: resp.data.id,
            tipo_mensaje: "Calificación y comentario del Jefe"
          }
        ]
      }
      await RequestTrackingServices.mailSendRequestTracking(mail)
      toastr.success(messages.correoEnviado, '', {
        progressBar: true,
        rtl: true,
      })
    }
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_REQUEST_TRACKING,
      payload: false,
    });
  }
};

export const deleteRequestTracking = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_REQUEST_TRACKING,
      payload: true,
    });
    await RequestTrackingServices.deleteRequestTracking(id);
    const { requestTrackings, requestTrackingsLength } = getState().requestTracking;
    requestTrackings.splice(index, 1);
    dispatch({
      type: actions.GET_REQUEST_TRACKING,
      payload: {
        requestTrackings: requestTrackings,
        requestTrackingsLength: requestTrackingsLength - 1,
      },
    });
    dispatch({
      type: actions.REQUEST_TRACKING_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.REQUEST_TRACKING_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_REQUEST_TRACKING,
      payload: false,
    });
  }
};